
export default {
  props: {
    primary: { type: Object, default: () => {} },
  },

  data() {
    return { isPlaying: this.primary.autoplay };
  },

  mounted() {
    if (this.isMobile && this.primary.internal_mobile_url) {
      this.$refs["video-item"].setAttribute(
        "src",
        `${this.primary.internal_mobile_url.url}#t=0.05`
      );
    }

    if (this.isTablet && this.primary.internal_tablet_url) {
      this.$refs["video-item"].setAttribute(
        "src",
        `${this.primary.internal_tablet_url.url}#t=0.05`
      );
    }
  },

  destroyed() {
    this.pauseVideo();
  },

  methods: {
    playVideo() {
      this.$refs["video-item"]?.play?.();
    },
    pauseVideo() {
      this.$refs["video-item"]?.pause?.();
    },
  },
};
